import { isShopify, type Platform, useEnv } from '../../../context/env-context';
import { CUSTOMER_GROUP_BASE_SLUG, CUSTOMER_GROUP_BASE_TAG } from '../constants';

function getCustomerGroupTagLink(
  tag: string,
  connectedPlatform?: Platform,
  storeId?: string,
): string | undefined {
  if (!connectedPlatform || !storeId) {
    return undefined;
  }

  if (isShopify(connectedPlatform)) {
    return `https://${storeId}/admin/customers?segment_query=customer_tags%20CONTAINS%20%27${encodeURIComponent(tag)}%27%20`;
  }

  // TODO: get TagLink for wix

  return undefined;
}

/**
 * The platform's own customer groups page, where customers are tagged into groups.
 * Undefined when the platform has no known one (falls back to /customers).
 */
export function getPlatformCustomersLink(
  connectedPlatform?: Platform,
  storeId?: string,
): string | undefined {
  if (!connectedPlatform || !storeId) {
    return undefined;
  }

  if (isShopify(connectedPlatform)) {
    return `https://${storeId}/admin/customers`;
  }

  if (connectedPlatform === 'wix') {
    return `https://manage.wix.com/dashboard/${storeId}/contacts`;
  }

  return undefined;
}

type TagWithLink = {
  tag: string;
  link: string | undefined;
};

export function useCustomerGroupTag(slug?: string): {
  tags: Array<TagWithLink>;
} {
  const { connected_platform, store_id } = useEnv();

  if (!slug) {
    return { tags: [] };
  }

  const tagNames = [CUSTOMER_GROUP_BASE_TAG];
  if (slug !== CUSTOMER_GROUP_BASE_SLUG) {
    tagNames.push(`${CUSTOMER_GROUP_BASE_TAG}-${slug}`);
  }

  return {
    tags: tagNames.map((tag) => ({
      tag,
      link: getCustomerGroupTagLink(tag, connected_platform, store_id),
    })),
  };
}
